import store from '@/stores/store';

let pendingPromise = null;

async function getCountryFromIp() {
  // Si ya está en el store, lo usamos directo
  if (store.state.main.ipCountry) {
    return store.state.main.ipCountry;
  }

  // Si ya hay una promesa en curso, la reutilizamos
  if (pendingPromise) {
    return pendingPromise;
  }

  // Creamos la promesa y la guardamos
  pendingPromise = (async () => {
    const request = await fetch(`https://ipinfo.io/json?token=${process.env.VUE_APP_IP_INFO_KEY}`);
    const ipData = await request.json();
    const { country } = ipData;
    await store.dispatch('setIpCountry', country);
    return country;
  })();

  // Una vez resuelta, limpiamos la referencia
  pendingPromise.finally(() => {
    pendingPromise = null;
  });

  return pendingPromise;
}

export default getCountryFromIp;
